var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex-grow-1",
    style: {
      'background-color': _vm.order.skin.page_background_color
    }
  }, [_vm.showEditGroupVideoBlob ? _c('group-video-editor', {
    key: _vm.showEditGroupVideoBlob.group_video.project_id + _vm.showEditGroupVideoBlob.group_video.template_id,
    attrs: {
      "purchase-dialog": "",
      "project-id": _vm.showEditGroupVideoBlob.group_video.project_id,
      "order": _vm.order,
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.showEditGroupVideoBlob = null;
      }
    }
  }) : _vm._e(), _vm.showGiftcardBlob ? [_vm.order.state == 'PENDING' ? _c('giftcard-edit-dialog', {
    attrs: {
      "order": _vm.order,
      "blob": _vm.showGiftcardBlob,
      "max-giftcard-value": _vm.maxGiftcardValue,
      "max-giftcard-value-remaining": _vm.maxGiftcardValueRemaining
    },
    on: {
      "input": function ($event) {
        _vm.showGiftcardBlob = null;
      }
    }
  }) : _c('giftcard-add-dialog', {
    attrs: {
      "no-mutation": "",
      "order-id": _vm.orderId,
      "order": _vm.order,
      "blob": _vm.showGiftcardBlob,
      "locked": _vm.order.state == 'CANCELLED',
      "max-value": _vm.maxGiftcardValueRemaining
    },
    on: {
      "input": function ($event) {
        _vm.showGiftcardBlob = null;
      },
      "complete": function ($event) {
        return _vm.$emit('load-order');
      }
    }
  })] : _vm._e(), _vm.showRSVP ? _c('form-rsvp-recipient-dialog', {
    attrs: {
      "token": _vm.orderId,
      "order": _vm.order,
      "preview": true,
      "is-sample": true
    },
    on: {
      "edit-event": function ($event) {
        _vm.showRSVP = false;
        _vm.$router.push({
          hash: '#event'
        });
      }
    },
    model: {
      value: _vm.showRSVP,
      callback: function ($$v) {
        _vm.showRSVP = $$v;
      },
      expression: "showRSVP"
    }
  }) : _vm._e(), _c('card-background', {
    attrs: {
      "src": _vm.order.skin.page_background_img
    }
  }), _vm.order.design_id == _vm.nullCoverDesignId ? _c('group-video-editor', {
    key: _vm.groupVideoBlob.group_video.project_id + _vm.groupVideoBlob.group_video.template_id,
    staticClass: "fill-height",
    attrs: {
      "block": "",
      "purchase-dialog": "",
      "project-id": _vm.groupVideoBlob.group_video.project_id,
      "order": _vm.order
    }
  }) : _c('card-editor', {
    staticClass: "overflow-hidden",
    attrs: {
      "order-id": _vm.orderId,
      "mode": _vm.order.state == 'PENDING' ? 'purchase' : _vm.order.state == 'CANCELLED' ? 'view' : 'edit',
      "card": _vm.order,
      "padding-top": _vm.paddingTop,
      "is-owner": true,
      "has-group-video": !!_vm.groupVideoBlob,
      "max-giftcard-value": _vm.maxGiftcardValueRemaining,
      "show-help": _vm.global.showHelp,
      "show-giftcard-block": _vm.orderDirty,
      "show-automation-opts": _vm.automation
    },
    on: {
      "click-group-video": function (x) {
        return _vm.showEditGroupVideoBlob = x;
      },
      "click-giftcard": function (x) {
        if (_vm.orderDirty) _vm.$confirm({
          title: 'Unsaved changes',
          msg: 'Please save or discard your other changes before adding a gift card',
          buttons: ['Ok'],
          primary: 'Ok'
        });else _vm.showGiftcardBlob = x;
      },
      "click-rsvp": function ($event) {
        _vm.showRSVP = true;
      },
      "click-add-group-video": function ($event) {
        return _vm.$router.push({
          name: 'catalog-video'
        });
      },
      "step-to": function (v) {
        return _vm.$router.push({
          hash: '#' + v
        });
      },
      "reload": function ($event) {
        return _vm.$emit('load-order');
      }
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }